import axios from 'axios';

export const createChatroom = async (employerId, jobSeekerId) => {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}chat/create`, { employerId, jobSeekerId });
    return response.data;
};

export const getChatroom = async (employerId, jobSeekerId) => {

    const response = await axios.get(`${process.env.REACT_APP_API_URL}chat/${employerId}/${jobSeekerId}`);
    return response.data;
};
export const getAllChatroom = async (accountType, userId) => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}chat/${accountType}/${userId}`);

    return response.data;
};

export const sendMessage = async (chatroomId, senderId, messageContent) => {
    const timestamp = new Date().toISOString();
    const response = await axios.post(`${process.env.REACT_APP_API_URL}messages/send`, { 
        chatroomId, 
        senderId, 
        messageContent,
        timestamp  // Include timestamp when sending message
    });
    return response.data;
};

export const getMessages = async (chatroomId, limit = 20, offset = 0) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}messages/${chatroomId}`, {
            params: { limit, offset }
        });
        
        // Ensure messages have unique IDs to prevent duplicates in the UI
        const messages = response.data.map(msg => ({
            ...msg,
            id: msg.id || `server-${msg.createdAt}-${Math.random().toString(36).substring(2, 9)}`
        }));
        
        return messages;
    } catch (error) {
        console.error('Error fetching messages:', error);
        throw error;  // You can handle this further based on your app's needs
    }
};